var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 38,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#FFF09F"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M17.398 23.543c0-.683.017-.859-.06-1.175a2.15 2.15 0 0 0-2.088-1.641h-.625a2.15 2.15 0 0 0-2.148 2.148v.668a1.02 1.02 0 0 0-.938 1.018v3.816c0 .563.458 1.021 1.021 1.021h4.754c.564 0 1.022-.458 1.022-1.021v-3.816c0-.535-.413-.976-.938-1.018m-3.75-.668c0-.538.438-.977.977-.977.599 0 1.12-.084 1.459.47.18.293.143.493.143 1.171h-2.579zM26.371 12.602H11.63A2.63 2.63 0 0 0 9 15.23v.497h20v-.497c0-1.45-1.18-2.628-2.629-2.628"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9 23.645a2.63 2.63 0 0 0 1.367 2.305c0-1.346-.178-2.407.94-3.188.143-4.335 7.12-4.299 7.261 0 1.163.813.94 1.998.94 3.511h6.863c1.45 0 2.629-1.179 2.629-2.628v-6.747H9zm11.29-3.986c0-.79.642-1.432 1.432-1.432h3.306c.79 0 1.433.642 1.433 1.432v.807c0 .79-.643 1.432-1.433 1.432h-3.306c-.79 0-1.433-.642-1.433-1.432z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M21.722 20.727c3.335 0 3.567.106 3.567-.261 0-.672.086-1.068-.26-1.068-3.336 0-3.568-.106-3.568.261 0 .672-.086 1.068.26 1.068"
})));
export default SvgPayment;